// Only sets the star fill percentage here — never the review count, and never unhides the badge.
// The count comes from an unreliable scraped attribute that doesn't match the widget's real total
// (previously caused a visible "99 then corrects to 91" flash on load). The count and the reveal are
// both handled exclusively by reviews-carousel-group.js once it has confirmed, reliable data from the
// Judge.me widget itself, so the badge only ever appears once, already showing the correct number.
document.addEventListener('DOMContentLoaded', function () {
  var badge = document.querySelector('[data-pdp-shop-rating]');

  if (!badge) {
    return;
  }

  var source = document.querySelector('[data-shop-average-rating]');
  var rating = source ? parseFloat(source.getAttribute('data-shop-average-rating')) : NaN;

  if (!rating || rating <= 0) {
    return;
  }

  var fillPercent = Math.max(0, Math.min(100, (rating / 5) * 100));

  badge.querySelector('[data-pdp-shop-rating-fill]').style.width = fillPercent + '%';
});
